import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevisionOld: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTelevisionOld"><Path d="M2.5 6.5H12H21.5V20.5H2.5V6.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11.6965 6.26398L7.5 3" stroke="currentColor" strokeLinecap="square"/><Path d="M12.3027 6.26398L16.4993 3" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTelevisionOld;
